import {
  check,
  loading1,
  notification,
  grid,
  logo1,
  logo2,
  logo3,
  logo4,
  logo5,
} from "../assets";

export const navigation = [
  {
    id: "0",
    title: "Features",
    url: "#features",
  },
  {
    id: "1",
    title: "Pricing",
    url: "#pricing",
  },
  {
    id: "2",
    title: "How to use",
    url: "#how-to-use",
  },
  {
    id: "3",
    title: "Roadmap",
    url: "#roadmap",
  },
  {
    id: "4",
    title: "New account",
    url: "#signup",
    onlyMobile: true,
  },
  {
    id: "5",
    title: "Sign in",
    url: "#login",
    onlyMobile: true,
  },
];

export const heroIcons = [
  {
    id: "0",
    icon: logo1,
    title: "Web Development",
  },
  {
    id: "1",
    icon: logo2,
    title: "Mobile Development",
  },
  {
    id: "2",
    icon: logo3,
    title: "Cloud Services",
  },
  {
    id: "3",
    icon: logo4,
    title: "AI Solutions",
  },
  {
    id: "4",
    icon: logo5,
    title: "Data Analytics",
  },
];

export const notificationImages = ["/notification/image-1.png", "/notification/image-2.png"];

export const roadmap = [
  {
    id: "0",
    title: "Voice recognition",
    status: "done",
    date: "May 2023",
    text: "Implement advanced voice recognition capabilities.",
    imageUrl: "/roadmap/image-1.png",
    colorful: true,
  },
  {
    id: "1",
    title: "Real-time collaboration",
    status: "progress",
    date: "July 2023",
    text: "Enable seamless real-time collaboration features.",
    imageUrl: "/roadmap/image-2.png",
  },
  {
    id: "2",
    title: "API Integration",
    status: "done",
    date: "September 2023",
    text: "Complete integration with major third-party APIs.",
    imageUrl: "/roadmap/image-3.png",
  },
  {
    id: "3",
    title: "AI-powered analytics",
    status: "progress",
    date: "December 2023",
    text: "Launch AI-driven analytics dashboard.",
    imageUrl: "/roadmap/image-4.png",
  },
];

export const benefits = [
  {
    id: "0",
    title: "AI-Powered Analytics",
    text: "Transform your data into actionable insights with our advanced AI analytics platform. Leverage machine learning algorithms to predict trends, identify patterns, and make data-driven decisions.",
    backgroundUrl: "/assets/benefits/card-1.svg",
    iconUrl: "/assets/benefits/icon-1.svg",
    features: [
      "Real-time data processing",
      "Predictive analytics",
      "Custom dashboards",
      "Automated reporting",
      "Anomaly detection"
    ]
  },
  {
    id: "1",
    title: "Smart Automation",
    text: "Streamline your workflows and boost productivity with intelligent automation solutions. Our AI-driven tools handle repetitive tasks, allowing your team to focus on strategic initiatives.",
    backgroundUrl: "/assets/benefits/card-2.svg",
    iconUrl: "/assets/benefits/icon-2.svg",
    features: [
      "Workflow optimization",
      "Process automation",
      "Task scheduling",
      "Integration capabilities",
      "Performance monitoring"
    ]
  },
  {
    id: "2",
    title: "Natural Language Processing",
    text: "Harness the power of advanced NLP to understand and process human language. From sentiment analysis to document processing, our AI makes sense of unstructured text data.",
    backgroundUrl: "/assets/benefits/card-3.svg",
    iconUrl: "/assets/benefits/icon-3.svg",
    features: [
      "Sentiment analysis",
      "Text classification",
      "Language translation",
      "Document processing",
      "Chatbot integration"
    ]
  },
  {
    id: "3",
    title: "Computer Vision",
    text: "Unlock new possibilities with state-of-the-art computer vision technology. Our AI systems can analyze, understand, and process visual information with remarkable accuracy.",
    backgroundUrl: "/assets/benefits/card-4.svg",
    iconUrl: "/assets/benefits/icon-4.svg",
    features: [
      "Image recognition",
      "Object detection",
      "Video analysis",
      "Face recognition",
      "Visual search"
    ]
  }
];

export const integrations = [
  {
    id: "0",
    title: "Slack Integration",
    text: "Connect your AI workflows directly with Slack. Automate notifications, responses, and data sharing across your team's channels.",
    backgroundUrl: "/assets/benefits/card-1.svg",
    iconUrl: "/assets/benefits/icon-1.svg",
    features: [
      "Real-time notifications",
      "Custom bot commands",
      "Channel automation",
      "Thread management"
    ]
  },
  {
    id: "1",
    title: "GitHub Integration",
    text: "Streamline your development workflow with AI-powered code review, automated testing, and deployment assistance.",
    backgroundUrl: "/assets/benefits/card-2.svg",
    iconUrl: "/assets/benefits/icon-2.svg",
    features: [
      "Automated code review",
      "CI/CD pipeline",
      "Issue tracking",
      "Pull request analysis"
    ]
  },
  {
    id: "2",
    title: "Google Workspace",
    text: "Enhance your productivity with AI integration across Google Docs, Sheets, and other Google Workspace applications.",
    backgroundUrl: "/assets/benefits/card-3.svg",
    iconUrl: "/assets/benefits/icon-3.svg",
    features: [
      "Smart document analysis",
      "Data automation",
      "Calendar management",
      "Email assistance"
    ]
  },
  {
    id: "3",
    title: "Microsoft Teams",
    text: "Seamlessly integrate AI capabilities into your Microsoft Teams workspace for enhanced collaboration and automation.",
    backgroundUrl: "/assets/benefits/card-4.svg",
    iconUrl: "/assets/benefits/icon-4.svg",
    features: [
      "Meeting summaries",
      "Task automation",
      "Chat assistance",
      "File management"
    ]
  },
  {
    id: "4",
    title: "Salesforce",
    text: "Power up your CRM with AI-driven insights, automated lead scoring, and intelligent customer engagement tools.",
    backgroundUrl: "/assets/benefits/card-5.svg",
    iconUrl: "/assets/benefits/icon-1.svg",
    features: [
      "Lead scoring",
      "Sales forecasting",
      "Customer insights",
      "Pipeline automation"
    ]
  },
  {
    id: "5",
    title: "Jira Integration",
    text: "Optimize your project management with AI-powered task prioritization, sprint planning, and resource allocation.",
    backgroundUrl: "/assets/benefits/card-6.svg",
    iconUrl: "/assets/benefits/icon-2.svg",
    features: [
      "Sprint automation",
      "Task prioritization",
      "Resource planning",
      "Progress tracking"
    ]
  }
];

export const pricing = [
  {
    id: "0",
    title: "Basic",
    description: "Perfect for individual developers",
    price: 0,
    features: [
      "Access to basic AI features",
      "Limited API calls",
      "Community support",
      "Basic analytics",
    ],
  },
  {
    id: "1",
    title: "Professional",
    description: "Ideal for growing businesses",
    price: 49,
    popular: true,
    features: [
      "All Basic features",
      "Unlimited API calls",
      "Priority support",
      "Advanced analytics",
      "Custom integrations",
    ],
  },
  {
    id: "2",
    title: "Enterprise",
    description: "For large-scale organizations",
    price: null,
    features: [
      "All Professional features",
      "Dedicated support",
      "Custom AI models",
      "Advanced security",
      "SLA guarantee",
    ],
  },
];
